import { Typography } from "@mui/material";
import { FirstMessage,
  FirstMessageBox } from "./style";
import AddCommentIcon from '@mui/icons-material/AddComment'
import { useTranslation } from 'react-i18next';

export default function EmptyDashboard (props) {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'dashboard' });

  const handleClick = () => {
    props.handleCreateNewMessage()
  }
  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  if (props.user?.type === 'user') {
    return (
      <FirstMessageBox dir={direction}>
        <AddCommentIcon
          onClick={handleClick}
          sx={{
            fontSize: 100,
          }}
          />
        <Typography variant="span" align="center" sx={{color: '#000', padding: '20px'}}>
          {t('empty_user_hint_1')}
          <FirstMessage onClick={handleClick}>
            {t('here')}
          </FirstMessage>
          {t('empty_user_hint_2')}
        </Typography>
      </FirstMessageBox>
    )
  }

  return (
    <FirstMessageBox dir={direction}>
      <Typography variant="span" align="center" sx={{color: '#000'}}>
        {t('empty_list')}
      </Typography>
    </FirstMessageBox>
  )
}
